import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { debugId, toDebugString } from "./debug";
import { EndpointError } from "./types";
import { evaluateRules } from "./utils";
export var resolveEndpoint = function resolveEndpoint(ruleSetObject, options) {
  var _options$logger, _options$logger$debug, _options$logger2, _options$logger2$debu;
  var endpointParams = options.endpointParams,
    logger = options.logger;
  var parameters = ruleSetObject.parameters,
    rules = ruleSetObject.rules;
  (_options$logger = options.logger) === null || _options$logger === void 0 ? void 0 : (_options$logger$debug = _options$logger.debug) === null || _options$logger$debug === void 0 ? void 0 : _options$logger$debug.call(_options$logger, "".concat(debugId, " Initial EndpointParams: ").concat(toDebugString(endpointParams)));
  var paramsWithDefault = Object.entries(parameters).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      v = _ref2[1];
    return v.default != null;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      k = _ref4[0],
      v = _ref4[1];
    return [k, v.default];
  });
  if (paramsWithDefault.length > 0) {
    var _iterator = _createForOfIteratorHelper(paramsWithDefault),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _endpointParams$param;
        var _step$value = _slicedToArray(_step.value, 2),
          paramKey = _step$value[0],
          paramDefaultValue = _step$value[1];
        endpointParams[paramKey] = (_endpointParams$param = endpointParams[paramKey]) !== null && _endpointParams$param !== void 0 ? _endpointParams$param : paramDefaultValue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var requiredParams = Object.entries(parameters).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      v = _ref6[1];
    return v.required;
  }).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      k = _ref8[0];
    return k;
  });
  var _iterator2 = _createForOfIteratorHelper(requiredParams),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var requiredParam = _step2.value;
      if (endpointParams[requiredParam] == null) {
        throw new EndpointError("Missing required parameter: '".concat(requiredParam, "'"));
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var endpoint = evaluateRules(rules, {
    endpointParams: endpointParams,
    logger: logger,
    referenceRecord: {}
  });
  (_options$logger2 = options.logger) === null || _options$logger2 === void 0 ? void 0 : (_options$logger2$debu = _options$logger2.debug) === null || _options$logger2$debu === void 0 ? void 0 : _options$logger2$debu.call(_options$logger2, "".concat(debugId, " Resolved endpoint: ").concat(toDebugString(endpoint)));
  return endpoint;
};